import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
/**
 * 文件名上传 模块
 * @module upload
 */

import axios from 'axios';
import { dataURItoBlob } from "./image";
import cookie from "./cookie";

/**
 *
 * @method uploadPic
 * @param  { Object } param 配置参数
 * @param  { Blob | String } param.file 必填，二进制文件对象或者base64字符串
 * @param  { Function } param.onSuccess 必填，上传成功的回调，返回三个参数，分别是图片地址，接口返回信息，以及完整的响应信息
 * @param  { Object } param.options 选填，上传图片的配置项
 * @param  { Boolean } param.options.isLogin 是否需要处理登录逻辑，默认情况下没有PPU会自动生成sign，实现无登录上传
 * @param  { String } param.options.mainHost 上传的接口域名，可选值为 zhuanzhuan.com 和 zhuanspirit.com。 默认会根据当前域名自动使用zhuanzhuan.com 或 zhuanspirit.com
 * @param  { Object } param.options.params 需要填充进上传的参数，例如：{businessType: 'arch'}， 具体文档见 http://dashen.zhuanspirit.com/pages/viewpage.action?pageId=53947298
 * @param  { String } param.options.type 默认值：image/png， 上传的文件类型，用于指定传入的base64的类型，如果传入的是dataURI便不需要设置
 * @param  { Function } param.onError 选填，上传失败的回调
 * @param  { Function } param.onProgress 选填，上传中的回调，返回0-100之间的数
 * @return { void } 无
 *
 */
export function uploadPic(_ref) {
  var file = _ref.file,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? {} : _ref$options,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? function () {} : _ref$onError,
    _ref$onProgress = _ref.onProgress,
    onProgress = _ref$onProgress === void 0 ? function () {} : _ref$onProgress,
    onSuccess = _ref.onSuccess;
  // 上传流程如下
  // 1. 生成二进制文件对象 Blob 类型
  // 2. 创建 FormData 实例对象
  // 3. 使用 xhr/fetch/axios 等方式，上传实例对象到服务端

  var actionURL = getActionURL(options); // 上传的接口地址

  // 1. 处理文件对象，如果不是Blob/File对象，则认为是base64，需要转换为Blob
  if (!(file instanceof Blob)) {
    // 处理dataURI的情况
    if (file.indexOf('base64,') === -1) {
      file = "data:".concat(options.type || 'image/png', ";base64,").concat(file);
    }
    file = dataURItoBlob(file);
  }

  // 2. 创建 FormData，并按接口要求填充数据
  var multipartFile = new FormData();
  multipartFile.append('path', '/zhuanzh/');
  if (options.params instanceof Object) {
    Object.keys(options.params).forEach(function (key) {
      multipartFile.append(key, options.params[key]);
    });
  }
  multipartFile.append('multipartFile', file);

  // 如果在zhuanzhuan.com域名下，且没有PPU，那么就需要手动设置sign值才可以上传
  if (options.isLogin !== false) {
    if (actionURL.mainHost === 'zhuanzhuan.com' && !cookie.getPPU()['UID']) {
      var sign = window.btoa(encodeURIComponent(Date.now())).split('').reverse().join('');
      multipartFile.append('sign', sign);
    }
  }

  // 3. 上传文件
  doUpload({
    multipartFile: multipartFile,
    actionURL: actionURL,
    onError: onError,
    onProgress: onProgress,
    onSuccess: onSuccess
  });
}

// 得到真实的上传地址
function getActionURL(options) {
  var mainHost = options.mainHost;
  if (!mainHost) {
    mainHost = document.domain.split('.').slice(-2).join('.');
  }
  if (!['zhuanzhuan.com', 'zhuanspirit.com'].includes(mainHost)) {
    mainHost = 'zhuanzhuan.com';
  }
  return {
    mainHost: mainHost,
    url: "//mediaproxy.".concat(mainHost, "/media/picture/upload")
  };
}

// 上传的具体逻辑
function doUpload(_ref2) {
  var multipartFile = _ref2.multipartFile,
    actionURL = _ref2.actionURL,
    onError = _ref2.onError,
    onProgress = _ref2.onProgress,
    onSuccess = _ref2.onSuccess;
  // 使用axios来调用上传接口
  axios.post(actionURL.url, multipartFile, {
    withCredentials: true,
    responseType: 'json',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: function onUploadProgress(progressEvent) {
      var complete = progressEvent.loaded / progressEvent.total * 100 | 0;
      onProgress(complete);
    }
  }).then(function (response) {
    var res = response.data || {};
    if (res.respCode === 0) {
      onSuccess("https://pic".concat(Math.ceil(Math.random() * 6), ".zhuanstatic.com/zhuanzh/").concat(res.respData), res, response);
    } else {
      onError({
        code: 2,
        message: res.respMsg,
        stack: res
      });
    }
  })["catch"](function (e) {
    onError({
      code: 2,
      message: '上传出错',
      stack: e
    });
  });
}
export default {
  uploadPic: uploadPic
};